import { reactive } from 'vue';
import { captureException } from '@sentry/vue';

// The application owns its notification lifetime, so Undo survives list removal.
// Messages are text; the host never interprets brew names as HTML.
export function createNotifications() {
  const items = reactive([]);
  const timers = new Map();
  let nextId = 0;
  function remove(id) {
    clearTimeout(timers.get(id)); timers.delete(id);
    const index = items.findIndex(item => item.id === id);
    if (index >= 0) items.splice(index, 1);
  }
  function show(message, options = {}, kind = 'success') {
    const id = ++nextId;
    const toast = { goAway(delay = 0) {
      clearTimeout(timers.get(id));
      if (delay > 0) timers.set(id, setTimeout(() => remove(id), delay));
      else remove(id);
    } };
    const actions = options.action ? [].concat(options.action) : [];
    items.push({ id, message, kind, actions: actions.map(action => {
      const control = reactive({ text: action.text, pending: false, async run(event) {
        if (control.pending) return;
        control.pending = true;
        try { await action.onClick(event, toast); }
        catch (error) { captureException(error); service.error('Unable to complete this action. Check your connection and try again.'); }
        finally { control.pending = false; }
      } });
      return control;
    }) });
    const duration = options.duration === undefined ? 5000 : options.duration;
    if (duration > 0) timers.set(id, setTimeout(() => remove(id), duration));
    return toast;
  }
  const service = { items, show,
    success: (message, options) => show(message, options),
    error: (message, options) => show(message, options, 'error'),
    clear() { for (const id of [...timers.keys()]) remove(id); items.splice(0); },
    install(app) { app.config.globalProperties.$toasted = service; app.onUnmount(service.clear); }
  };
  return service;
}
